import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { CampaignService } from '@brafton/atlas-api-client';
import { CampaignProject, IPagedList } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'shared-filter-panel-campaigns',
  templateUrl: './filter-panel-campaigns.component.html',
  styleUrls: ['./filter-panel-campaigns.component.scss'],
  host: { class: 'shared-filter-panel-campaigns' },
})
export class SharedFilterPanelCampaignsComponent implements OnInit {
  @Input() campaigns: Filter[] = [];
  @Output() campaignsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() feedId?: number;

  campaigns$!: Observable<CampaignProject[]>;

  constructor(private campaignService: CampaignService) { }

  ngOnInit() {
    this.campaigns$ = this.campaignService.listCampaigns(1, 40, this.feedId?.toString()).pipe(map((c: IPagedList<CampaignProject>) => c.items));
  }

  add(campaignDef: CampaignProject) {
    if (!this.campaigns.find((sp) => sp.value === campaignDef.id)) {
      this.campaigns.push({ value: campaignDef.id, displayName: campaignDef.name, type: 'contentType' } as Filter);
    }
    this.campaignsChange.emit(this.campaigns);
  }

  remove(campaignDef: CampaignProject) {
    const index = this.campaigns.findIndex((sp) => sp.value === campaignDef.id);
    if (index > -1) {
      this.campaigns.splice(index, 1);
    }
    this.campaignsChange.emit(this.campaigns);
  }

  clear() {
    this.campaigns = [];
    this.campaignsChange.emit(this.campaigns);
  }

  isSelected(campaignDef: CampaignProject): boolean {
    if (!this.campaigns) return false;
    if (this.campaigns.find((sp) => sp.value === campaignDef.id)) return true;
    else return false;
  }
}
